import React, { useState } from 'react';

import './desktop-brand-product-list-template-style.scss';

import Typography from '@src/componentsNew/Typography/Typography';
import TextWithNewlines from '@src/componentsNew/TextWithNewlines';
import Carousel from '@src/componentsNew/Carousel/Carousel';
import DesktopProductListFilter from '@src/componentsNew/Filter/DesktopProductListFilter/DesktopProductListFilter';
import DesktopProductListSortingFilter from '@src/componentsNew/Filter/DesktopProductListFilter/DesktopProductListSortingFilter';
import DesktopBasicProductList from '@src/componentsNew/ProductList/Basic/DesktopBasicProductList';

import useIsComDomain from '@src/hooks/useIsComDomain';

import { productsVariables } from '@components/ProductPage/ProductList/__generated__/products';
import { StockAvailability, ProductOrderField, OrderDirection } from '__generated__/globalTypes';
import {
  brand_brand_images,
  brand_brand_categories_edges,
} from '@src/components/ProductPage/BrandPage/__generated__/brand';
import { DESKTOP_PRODUCT_LIST_REQUEST_COUNT, getInvisibleBrandIds } from '@src/utils/constants';
import { getDBIdFromGraphqlId } from "@utils";

type IProps = {
  brandName: string;
  brandTnc: string;
  brandImages?: brand_brand_images[];
  brandCategories?: brand_brand_categories_edges[];
  currentBrandGraphqlId?: string;
};

const DesktopBrandProductListTemplate: React.FC<IProps> = ({
  brandName,
  brandTnc,
  brandImages,
  brandCategories,
  currentBrandGraphqlId,
}) => {
  const isComDomain = useIsComDomain();

  const initialVariables = {
    brand: currentBrandGraphqlId,
    stockAvailability: StockAvailability.IN_STOCK,
    sortBy: {
      field: ProductOrderField.POPULARITY,
      direction: OrderDirection.DESC,
    },
    first: DESKTOP_PRODUCT_LIST_REQUEST_COUNT,
    ...(isComDomain && { isMgs: true }),
  };

  const [variables, setVariables] = useState<productsVariables>(initialVariables);
  const [numOfProducts, setNumOfProducts] = useState<number>(0);

  const brandDbId = getDBIdFromGraphqlId(currentBrandGraphqlId, 'Brand')?.toString();
  if (getInvisibleBrandIds().includes(brandDbId)) {
    return null;
  }

  return (
    <div className="desktop-brand-product-list-template-wrapper">
      {brandImages?.length ? (
        <div className="brand-image-wrapper">
          <Carousel
            customSetting={{
              dots: false,
              infinite: true,
              centerMode: true,
              centerPadding: '0',
              autoplay: true,
              autoplaySpeed: 4000,
              speed: 2000,
              slidesToShow: 1,
              slidesToScroll: 1,
              className: 'brand-slider',
            }}
          >
            {brandImages.map((item) => (
              <img key={item.url} className="brand-image" src={item.url} alt={item?.alt ?? ''} />
            ))}
          </Carousel>
          {brandTnc ? (
            <div className="tnc-btn-wrapper">
              <div className="tnc-btn">T&Cs</div>
              <TextWithNewlines cName="tnc-content" text={brandTnc} />
            </div>
          ) : null}
        </div>
      ) : null}

      <div className={`brand-product-list-top-wrapper ${brandImages?.length ? 'sticky' : ''}`}>
        <div className="content-area">
          <Typography variant="h6" component="h6">
            {brandName}
          </Typography>
          {numOfProducts > 0 ? (
            <div className="sorting-filter-area">
              <Typography
                variant="body1"
                component="span"
                style={{ color: '#666666' }}
              >{`${numOfProducts} Items`}</Typography>

              <DesktopProductListSortingFilter variables={variables} setVariables={setVariables} />
            </div>
          ) : null}
        </div>
        <div className="divider" />
      </div>

      <div className={`main-area ${brandImages?.length ? 'sticky' : ''}`}>
        <div className="desktop-prodcut-list-filter-wrapper">
          <DesktopProductListFilter
            initialVariables={initialVariables}
            variables={variables}
            setVariables={setVariables}
            brandCategories={brandCategories}
          />
        </div>

        <div className={`products-area ${numOfProducts === 0 ? 'no-product' : ''}`}>
          <DesktopBasicProductList
            initialVariables={initialVariables}
            variables={variables}
            setNumOfProducts={setNumOfProducts}
          />
        </div>
      </div>
    </div>
  );
};

export default DesktopBrandProductListTemplate;
